import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VList,{attrs:{"dense":""}},[_c(VListItem,{on:{"click":function($event){$event.stopPropagation();return _vm.logOut($event)}}},[_c(VListItemAction,[_c(VIcon,[_vm._v("fa-sign-out-alt")])],1),_c(VListItemContent,[_c(VListItemTitle,[_vm._v("Logout")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }